<template>
  <v-app id="yhphoto">
    <v-main>
      <v-container fluid class="px-0 py-0">
        <template v-if="loaded">
          <parallaxHeader></parallaxHeader>
          <social-network></social-network>
          <about-me></about-me>
          <contact></contact>
          <footer-bar></footer-bar>
        </template>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import parallaxHeader from './components/header.vue'
import socialNetwork from './components/social.vue'
import aboutMe from './components/aboutme.vue'
import contact from './components/contact.vue'
import footerBar from './components/footer.vue'

export default {
  name: "App",
  created() {
    this.$vuetify.theme.dark = false;
    this.setData();
  },
  components: {
    parallaxHeader,
    socialNetwork,
    aboutMe,
    contact,
    footerBar
  },
  data: () => ({
    loaded: false,
  }),
  methods: {
    async setData() {
      let isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
      let photos = await this.$store.dispatch("setPhotos", isMobile);
      if (photos) {
        this.loaded = true
        let photoId = this.$store.state.photos[
          Math.floor(Math.random() * this.$store.state.photos.length)
        ].id;
        await this.$store.dispatch("setBackground", photoId, isMobile);
      }
    },
  },
};
</script>
